import routerOptions0 from "/home/runner/work/revolugo/revolugo/node_modules/.pnpm/nuxt@3.15.4_@types+node@22.15.21_eslint@9.27.0_rollup@4.41.0_sass-embedded@1.89.0_sass@_b79de274a22d692d3638a8396f725fe9/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}